import { useCallback, useContext, useEffect, useState } from "react";
import FilterReusableComp from "../../../../components/FilterReusableComp";
import SettingLayout from "../SettingLayout";
import "../../../../styles/dashboard/setting/SettingLayout.css";
import {
  RazorNumberFormat,
  RazorTable,
  RazorTableRow,
} from "../../../../components/razor-reuse";
import TitleTextFragment from "../../../../components/fragment/title-text/TitleTextFragment";
import PaginationFragment from "../../../../components/fragment/pagination/PaginationFragment";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCurrencies,
  getAllExchangeRate,
  getAllExchangeRateHistory,
} from "../../../../redux/settings";
import RootState from "../../../../redux/type";
import { capitalizeFirstLetter, formatTime } from "../../../../utils/Helper";
import TextColorFragment from "../../../../components/fragment/text-color/TextColorFragment";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../../routes/AllRoutes";
import StatusFragment from "../../../../components/fragment/status/StatusFragment";
import CurrencyText from "../../../../components/fragment/cur-text/CurrencyText";
import ActionContext from "../../../../context/ActionContext";

const ExchangeRateHistoryIndex = () => {
  const navigate = useNavigate();
  const { loading, all_currencies_drop, exchange_rates_history } = useSelector(
    (state: RootState) => state.settings
  );
  const actionCtx = useContext(ActionContext);
  const [currentPageVal, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const tableHeaderList = [
    "Currency Pair",
    "Eff. Rate",
    "Cur. Rate",
    "Provider",
    "FX Type",
    "Prev Mark",
    "Cur. Mark",
    "Updated By",
    "Date",
  ];

  useEffect(() => {
    if (all_currencies_drop?.length < 1) {
      dispatch(getAllCurrencies({} as any) as any);
    }
  }, [all_currencies_drop?.length, dispatch]);

  const [filterTwoVal, setFilterTwoVal] = useState<any>("");

  useEffect(() => {
    const id = localStorage?.getItem("cur-his-id");
    if (id) {
      const obj = {
        page: currentPageVal,
        status: filterTwoVal?.value || "",
        search: "",
        id: id,
      };
      dispatch(getAllExchangeRateHistory(obj as any) as any);
    } else {
      navigate(ALL_ROUTES?.DASHBOARD_SETTINGS_EXCHANGE_RATE);
    }
  }, [currentPageVal, filterTwoVal, dispatch, navigate]);

  const triggerCollapse = useCallback(() => {
    if (!actionCtx?.collapse)
      actionCtx?.setCollapse && actionCtx?.setCollapse();
  }, [actionCtx]);

  useEffect(() => {
    triggerCollapse();
  }, []);

  const formatOptionLabelTwo = ({ label, fromLabel, toLabel, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <TextColorFragment
            color={
              value === "active"
                ? "rgba(0, 153, 51, 1)"
                : value === "Pending"
                ? "rgba(255, 192, 67, 1)"
                : value === "inactive"
                ? "rgba(200, 16, 46, 1)"
                : ""
            }
            text={label}
          />
        </>
      );
    }
  };

  return (
    <>
      <SettingLayout
        back
        onBack={() => {
          navigate(ALL_ROUTES?.DASHBOARD_SETTINGS_EXCHANGE_RATE);
        }}
        hideBtn={loading || true}
        title="Exchange Rate History Page"
        btnLabel="Add New Exchange Rate"
        pageLoading={
          loading && Object?.keys(exchange_rates_history)?.length < 1
        }
      >
        <div className="exchange-rate-settings-wrap-index">
          {/* filter section start */}
          <FilterReusableComp
            className="search-reuse-box"
            hideExport
            onSearch={(param: any) => {
              if (String(param)?.length > 2) {
                const obj = {
                  search: param,
                };
                dispatch(getAllExchangeRate(obj as any) as any);
              }
              if (String(param)?.length < 1) {
                const obj = {
                  status: filterTwoVal?.value,
                };
                dispatch(getAllExchangeRate(obj as any) as any);
              }
            }}
            searchPlaceholder="Search for currency"
            onSelectTwo={(param) => {
              setFilterTwoVal(param);
            }}
            formatOptionLabelTwo={formatOptionLabelTwo}
            selectTwoValue={filterTwoVal}
            defaultSelectTwo="Rate Status"
            // selectTwoList={removeSelectedList(selectListTwo)}
          />
          {/* filter section end */}
          {/* table start */}
          <div
            onClick={() => {
              console.log(exchange_rates_history);
            }}
            className="table-section-box"
          >
            <RazorTable headerList={tableHeaderList}>
              {exchange_rates_history?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    key={idx}
                    one={
                      <div className="exchange-rate-box-fragment-reusable-comp">
                        <CurrencyText
                          url={chi?.source_currency?.code || "NIL"}
                          currency={chi?.source_currency?.code || "NIL"}
                        />
                        <div className="dash"></div>
                        <CurrencyText
                          url={chi?.destination_currency?.code || "NIL"}
                          currency={chi?.destination_currency?.code || "NIL"}
                        />
                      </div>
                    }
                    two={RazorNumberFormat(chi?.rate, {
                      symbol: chi?.rate?.symbol,
                      // hideDecimal: true,
                      hideSymbol: true,
                    })}
                    three={RazorNumberFormat(chi?.base_rate, {
                      symbol: chi?.rate?.symbol,
                      // hideDecimal: true,
                      hideSymbol: true,
                    })}
                    four={
                      chi?.provider === "exchange-rate-api"
                        ? "Ex Rate"
                        : "Aboki Fx"
                    }
                    five={capitalizeFirstLetter(chi?.fx_type) || "---"}
                    six={
                      <StatusFragment
                        className={
                          chi?.markup_percentage_prev ===
                          chi?.markup_percentage_curr
                            ? ""
                            : chi?.markup_percentage_prev >
                              chi?.markup_percentage_curr
                            ? "success"
                            : "failed"
                        }
                        text={`${chi?.markup_percentage_prev || 0}%` || "---"}
                      />
                    }
                    seven={
                      <StatusFragment
                        className={
                          chi?.markup_percentage_prev ===
                          chi?.markup_percentage_curr
                            ? ""
                            : chi?.markup_percentage_curr >
                              chi?.markup_percentage_prev
                            ? "success"
                            : "failed"
                        }
                        text={`${chi?.markup_percentage_curr || 0}%` || "---"}
                      />
                    }
                    eight={
                      <TitleTextFragment
                        titleSize="1.25rem"
                        title={chi?.updated_by?.name || ""}
                      />
                    }
                    nine={
                      // <RazorDateTime date={chi?.updated_at} />
                      <>
                        {formatTime(chi?.updated_at)?.split(",")?.[0]}
                        <p>{formatTime(chi?.updated_at)?.split(",")?.[1]}</p>
                      </>
                      // chi?.updated_at
                      //   ? formatTime(chi?.updated_at || "")
                      //   : "---"
                    }
                    // nine={
                    //   <TextColorFragment
                    //     color={
                    //       chi?.status === "active"
                    //         ? "rgba(0, 153, 51, 1)"
                    //         : chi?.status === "Pending"
                    //         ? "rgba(255, 192, 67, 1)"
                    //         : chi?.status === "inactive"
                    //         ? "rgba(200, 16, 46, 1)"
                    //         : ""
                    //     }
                    //     text={chi?.status}
                    //   />
                    // }
                    // seven={
                    //   <DotActionDropFragment
                    //     list={updateActionArray(
                    //       {
                    //         hide: chi?.status === "inactive",
                    //         label: "Deactivate",
                    //       },
                    //       {
                    //         hide: chi?.status !== "inactive",
                    //         label: "Activate",
                    //       }
                    //     )}
                    //     detail={chi}
                    //   />
                    // }
                    loading={loading}
                  />
                );
              })}
            </RazorTable>
          </div>
          {/* table end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={exchange_rates_history?.meta?.current_page || 1}
            perPage={exchange_rates_history?.meta?.per_page}
            totalPage={exchange_rates_history?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading}
          />
          {/* pagination  end */}
        </div>
      </SettingLayout>
    </>
  );
};

export default ExchangeRateHistoryIndex;
